<template>
  <div>
    <a @click="dialog = true" :class="styleClass"> {{ text }}</a>
    <v-dialog scrollable v-model="dialog" max-width="500px" height="300px">
      <v-card>
        <v-card-title class="text-h5"> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="pb-0 mb-0">Report a problem</v-col>
            <v-col cols="12" class="mb-1">
              <v-text-field
                outlined
                name="reporterTextField"
                v-model="reporter"
                label="Reporter email"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-textarea
                outlined
                name="textAreaProblemMessage"
                v-model="problemMessage"
                label="Message"
                :rules="[(v) => !!v || 'Message is required']"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="errorMsg != ''">
            <v-col cols="12" class="pb-0 mb-2">
              <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="green darken-1" @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="submit" :loading="loading">
            Send
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" color="success" outlined>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    styleClass: {
      type: String,
      default: "text-decoration-none",
    },
    text: {
      type: String,
      default: "Report a problem",
    },
  },
  data() {
    return {
      dialog: false,
      errorMsg: "",
      loading: false,
      problemMessage: "",
      reporter: "",

      snackbar: false,
      snackbarText: "",
    };
  },
  mounted() {
    this.reporter = this.$store.getters.getUser
      ? this.$store.getters.getUser
      : "anonymous";
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        this.errorMsg = "";
        if (this.problemMessage == "") {
          throw new Error("Message is required");
        }
        await this.$utils.callBackendPost(this, "/pub/reportProblem", {
          reporter: this.reporter,
          pageUrl: this.$route.fullPath,
          message: this.problemMessage,
        });
        this.dialog = false;
        this.snackbar = true;
        this.snackbarText = "Problem reported successfully";
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
